// // Button.js

// import React from "react";
// import PropTypes from "prop-types";

// const Button = ({
//   type = "button",
//   variant = "primary",
//   icon,
//   children,
//   isActive = true,
//   fullWidth = false,
//   isLoading = false,
//   ...props
// }) => {
//   const baseClasses = "flex items-center justify-center px-4 py-3 rounded-lg";
//   const variantClasses = {
//     primary:
//       "bg-agPrimary border-agPrimary hover:bg-agPrimaryDark text-white text-sm cursor-pointer",
//     secondary:
//       "buttonBorder border-agPrimary text-agPrimary text-sm bg-agSecondary hover:bg-agPrimaryLight cursor-pointer",
//     delete:
//       "bg-agRedBg text-agRed border-agRed buttonBorder hover:bg-agRedBgHover  text-sm cursor-pointer",
//     inactive: "bg-agInactive text-white cursor-not-allowed",
//   };
//   const activeClass = isActive
//     ? variantClasses[variant]
//     : variantClasses["inactive"];
//   const widthClass = fullWidth ? "w-full" : "";

//   return (
//     <button
//       type={type}
//       className={`${baseClasses} ${activeClass} ${widthClass}`}
//       disabled={!isActive || isLoading}
//       {...props}
//     >
//       {isLoading ? (
//         <span className="material-icons-round animate-spin">autorenew</span>
//       ) : (
//         <>
//           {icon && <span className="material-icons-round mr-2">{icon}</span>}
//           {children}
//         </>
//       )}
//     </button>
//   );
// };

// Button.propTypes = {
//   type: PropTypes.oneOf(["button", "submit", "reset"]),
//   variant: PropTypes.oneOf(["primary", "secondary", "inactive"]),
//   icon: PropTypes.string,
//   children: PropTypes.node.isRequired,
//   isActive: PropTypes.bool,
//   fullWidth: PropTypes.bool,
//   isLoading: PropTypes.bool,
// };

// export default Button;

import React from "react";
import PropTypes from "prop-types";

const Button = ({
  type = "button",
  variant = "primary",
  icon,
  children,
  isActive = true,
  fullWidth = false,
  isLoading = false,
  ...props
}) => {
  const baseClasses = "flex items-center justify-center px-4 py-3 rounded-lg";
  const variantClasses = {
    primary:
      "bg-agPrimary border-agPrimary hover:bg-agPrimaryDark text-white text-sm cursor-pointer",
    secondary:
      "buttonBorder border-agPrimary text-agPrimary text-sm bg-agSecondary hover:bg-agPrimaryLight cursor-pointer",
    delete:
      "bg-agRedBg text-agRed border-agRed buttonBorder hover:bg-agRedBgHover  text-sm cursor-pointer",
    inactive: "bg-agInactive text-white cursor-not-allowed",
  };
  const activeClass = isActive
    ? variantClasses[variant]
    : variantClasses["inactive"];
  const widthClass = fullWidth ? "w-full" : "";

  return (
    <button
      type={type}
      className={`${baseClasses} ${activeClass} ${widthClass}`}
      disabled={!isActive || isLoading}
      {...props}
    >
      {isLoading ? (
        <div className="loader"></div>
      ) : (
        <>
          {icon && <span className="material-icons-round mr-2">{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
};

Button.propTypes = {
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  variant: PropTypes.oneOf(["primary", "secondary", "inactive"]),
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  fullWidth: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default Button;
